import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";

// Pages
import Home from "./pages/Home";
import Tippspiele from "./pages/Tippspiele";
import WasKostetDiesesHaus from "./pages/WasKostetDiesesHaus";
import NeubauOderSanierung from "./pages/NeubauOderSanierung";
import WohnungKaufenOderMieten from "./pages/WohnungKaufenOderMieten";
import WasKostetEineSanierung from "./pages/WasKostetEineSanierung";
import BaufirmaMeran from "./pages/BaufirmaMeran";
import WohnenInSuedtirol from "./pages/WohnenInSuedtirol";
import HausbauInSuedtirol from "./pages/HausbauInSuedtirol";
import Immobilien from "./pages/Immobilien";
import HausUndBau from "./pages/HausUndBau";
import Suedtirol from "./pages/Suedtirol";
import Ratgeber from "./pages/Ratgeber";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />
          
          {/* Tippspiele */}
          <Route path="/tippspiele" element={<Tippspiele />} />
          <Route path="/tippspiele/was-kostet-dieses-haus" element={<WasKostetDiesesHaus />} />
          <Route path="/tippspiele/neubau-oder-sanierung" element={<NeubauOderSanierung />} />
          
          {/* Immobilien */}
          <Route path="/immobilien" element={<Immobilien />} />
          <Route path="/immobilien/wohnung-kaufen-oder-mieten" element={<WohnungKaufenOderMieten />} />
          
          {/* Haus und Bau */}
          <Route path="/haus-und-bau" element={<HausUndBau />} />
          <Route path="/haus-und-bau/was-kostet-eine-sanierung" element={<WasKostetEineSanierung />} />
          <Route path="/haus-und-bau/baufirma-meran" element={<BaufirmaMeran />} />
          
          {/* Südtirol */}
          <Route path="/suedtirol" element={<Suedtirol />} />
          <Route path="/suedtirol/wohnen-in-suedtirol" element={<WohnenInSuedtirol />} />
          
          {/* Ratgeber */}
          <Route path="/ratgeber" element={<Ratgeber />} />
          <Route path="/ratgeber/hausbau-in-suedtirol" element={<HausbauInSuedtirol />} />
          
          {/* Legal */}
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
